import _defineProperty from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Fetch from '../../../../services/Fetch';
import { apiURL } from '../../../../constants';
import SelectInputComponentField from '../SelectInputComponentField/SelectInputComponentField';

var CurrencyComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(CurrencyComponent, _Component);

  function CurrencyComponent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CurrencyComponent);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CurrencyComponent)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      currencies: []
    }, _this.FieldComponent = function (_ref) {
      var input = _ref.input,
          meta = _ref.meta,
          label = _ref.label,
          values = _ref.values,
          handleChange = _ref.handleChange,
          placeholder = _ref.placeholder,
          displayNotes = _ref.displayNotes;
      return React.createElement(SelectInputComponentField, _extends({
        input: input,
        values: values,
        handleChange: handleChange
      }, input, {
        meta: meta,
        label: label,
        placeholder: placeholder,
        displayNotes: displayNotes
      }));
    }, _temp));
  }

  _createClass(CurrencyComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      Fetch.getJSON("".concat(apiURL.API_ENUMS)).then(function (enums) {
        return _this2.setState({
          currencies: enums['Currencies']
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _React$createElement;

      var _this$props = this.props,
          name = _this$props.name,
          label = _this$props.label,
          handleChange = _this$props.handleChange,
          displayNotes = _this$props.displayNotes,
          placeholder = _this$props.placeholder,
          validate = _this$props.validate;
      var currencies = this.state.currencies;
      return React.createElement(Field, (_React$createElement = {
        name: name,
        validate: validate,
        component: this.FieldComponent,
        label: label
      }, _defineProperty(_React$createElement, "validate", validate), _defineProperty(_React$createElement, "values", currencies), _defineProperty(_React$createElement, "handleChange", handleChange), _defineProperty(_React$createElement, "displayNotes", displayNotes), _defineProperty(_React$createElement, "placeholder", placeholder), _React$createElement));
    }
  }]);

  return CurrencyComponent;
}(Component);

CurrencyComponent.propTypes = {
  name: PropTypes.string.isRequired,
  validate: PropTypes.array.isRequired,
  label: PropTypes.element.isRequired,
  placeholder: PropTypes.string,
  displayNotes: PropTypes.string,
  handleChange: PropTypes.func.isRequired
};
export default CurrencyComponent;